var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmojisi = function SvgEmojisi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor',
    "data-name": "Group 5799"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a8 8 0 1 0 8 8 8.024 8.024 0 0 0-8-8m0 14.4a6.4 6.4 0 1 1 6.4-6.4 6.42 6.42 0 0 1-6.4 6.4",
    "data-name": "Path 3926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 13.2H7.6a.513.513 0 0 0-.48.64 5.224 5.224 0 0 0 9.76 0 .513.513 0 0 0-.48-.64M12 15.6a3.82 3.82 0 0 1-2.24-.8h4.48a3.82 3.82 0 0 1-2.24.8",
    "data-name": "Path 3927"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1402"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmojisi);
export default ForwardRef;